<template>
	<div class="wrapper">
		<vs-tabs v-model="currentTab">
			<vs-tab label="Logs">
				<vs-table
					max-items="200"
					pagination
					:data="logs"
					noDataText="Aucune erreur enregistrée."
				>
					<template slot="thead">
						<vs-th
							class="text-center"
							style="pointer-events: auto"
							sort-key="log_time"
							>Log Time</vs-th
						>
						<vs-th
							class="text-center"
							style="pointer-events: auto"
							sort-key="message"
							>Message</vs-th
						>
						<vs-th
							class="text-center"
							style="pointer-events: auto"
							sort-key="funcName"
							>Function</vs-th
						>
					</template>
					<template slot-scope="{ data }">
						<vs-tr
							:data="data[indextr]"
							:key="indextr"
							v-for="(tr, indextr) in data"
						>
							<vs-td class="text-left">{{ data[indextr].log_time }}</vs-td>
							<vs-td class="text-left">{{ data[indextr].message }}</vs-td>
							<vs-td class="text-left">{{ data[indextr].funcName }}</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vs-tab>
			<vs-tab label="Scraping">
				<scraping-logs />
			</vs-tab>
		</vs-tabs>
	</div>
</template>

<script>
import ScrapingLogs from "@/components/logs/ScrapingLogs.vue";

export default {
	name: "Logs",
	components: { ScrapingLogs },
	data() {
		return {
			currentTab: 0,
			logs: [],
		};
	},
	created() {
		// The scraping failure mail links here with ?tab=scraping
		if (this.$route.query.tab === "scraping") this.currentTab = 1;
		this.fectchErrorLogs();
	},
	methods: {
		fectchErrorLogs() {
			this.$http
				.get(`/logs/backend/error?page=1&limit=200`)
				.then((response) => {
					this.logs = response.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style scoped>
.wrapper {
	text-align: center;
}
</style>
